import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, throwError } from "rxjs";
import { AuthService } from "./auth.service";
import { ConfigurationService } from "./configuration.service";
import { catchError, finalize, tap } from "rxjs/operators";
export class AggregatesInfo {
  public ColumnName: string;
  public Value: number;
}
export class PagingDataResult<T> {
  public Data: T[];
  public TotalPage: number;
  public AggregatesInfo: AggregatesInfo[];
}
export class GridFilter {
  public Type: string;
  public Filed: any;
  public Operator: any;
  public Value: any;
  public Skip: number;
  public Take: number;
  public Logic?: string;
}

type Queue = {
  replySubject: ReplaySubject<any>;
  model?: string;
};

type QueueList = {
  [key: string]: Queue;
};

type ApiStatusInQueueList = "notExist" | "exist" | "existWithSameApiNameAndOtherModel";

@Injectable()
export class HttpCommonService {
  private requestQueueList: QueueList = {};
  public apiBaseUrl: string;
  constructor(public http: HttpClient, private authService: AuthService, private configurations: ConfigurationService) {
    this.http = http;
    this.apiBaseUrl = `${this.configurations.baseUrl}/api/`;
  }
  stringifyModel(model: any) {
    return JSON.stringify(model);
  }
  create(apiName: string, model: any): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.post(url, this.stringifyModel(model), this.authService.getRequestHeaders()), model);
  }
  postCustom(apiName: string, model: any): Observable<any> {
    return this.handleRequest(apiName, this.http.post(apiName, this.stringifyModel(model), this.authService.getRequestHeaders()), model);
  }
  update(apiName: string, model: any): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.put(url + "/" + model["Id"], this.stringifyModel(model), this.authService.getRequestHeaders()), model);
  }

  put(apiName: string, model: any): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.put(url, this.stringifyModel(model), this.authService.getRequestHeaders()), model);
  }

  updateItem(apiName: string, model: any): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.put(url, this.stringifyModel(model), this.authService.getRequestHeaders()), model);
  }

  bulkUpdate(apiName: string, models: any[]): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.put(url + "/BulkUpdate", this.stringifyModel(models), this.authService.getRequestHeaders()), models);
  }
  bulkInsert(apiName: string, models: any[]): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.post(url + "/BulkInsert", this.stringifyModel(models), this.authService.getRequestHeaders()), models);
  }
  createlist(apiName: string, models: any[]): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.post(url, this.stringifyModel(models), this.authService.getRequestHeaders()), models);
  }
  bulkDelete(apiName: string, models: any[]): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.post(url + "/BulkDelete", this.stringifyModel(models), this.authService.getRequestHeaders()), models);
  }
  delete(apiName: string, id: any): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.delete(url + "/" + id, this.authService.getRequestHeaders()));
  }
  deleteByParameter(apiName: string): Observable<any> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.delete(url, this.authService.getRequestHeaders()));
  }
  getList<T>(apiName: string): Observable<T> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }
  getListWithParameter<T>(apiName: string, parameter1: number, parameter2: number): Observable<T> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.get<T>(url + "/" + parameter1 + "/" + parameter2, this.authService.getRequestHeaders()));
  }
  get<T>(apiName: string): Observable<T> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }

  getCustom<T>(apiName: string): Observable<T> {
    return this.handleRequest(apiName, this.http.get<T>(apiName, this.authService.getRequestHeaders()));
  }
  getControlsList<T>(apiName: string, custom?: boolean): Observable<T> {
    const url = this.apiBaseUrl + apiName + (!custom ? "/EntityInfo" : "");
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }
  getMaxCode<T>(apiName: string): Observable<T> {
    const url = this.apiBaseUrl + apiName + "/GetMaxCode";
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }
  getMaxCodeWithParameter<T>(apiName: string, id: number, parameter1: number, parameter2: number = undefined): Observable<T> {
    const url = this.apiBaseUrl + apiName + "/" + id + "/" + parameter1 + "/" + parameter2;
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }
  getItem<T>(apiName: string, id: number): Observable<T> {
    const url = this.apiBaseUrl + apiName + "/" + id;
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }
  getLookup(lookupName: string, parentId: number, parentName: string): Observable<any> {
    var params = null;
    if (parentId != null) {
      params = new URLSearchParams();
      params.set(parentName, parentId.toString());
    }
    const url = this.apiBaseUrl + "LookUp/" + lookupName;
    return this.handleRequest(url, this.http.get(url, this.authService.getRequestHeaders()));
  }
  getLookupByCategory(apiName: string, systemName: string, category: string): Observable<any> {
    const url = this.apiBaseUrl + apiName + "/" + systemName + "/" + category;
    return this.handleRequest(url, this.http.get(url, this.authService.getRequestHeaders()));
  }

  GetPaginingCount<T>(apiName: string, searchMember: string, filterValue: string, SortColumn: string = ""): Observable<T> {
    const url =
      this.apiBaseUrl + apiName + "/GetPaginingCount?searchMember=" + searchMember + "&filterValue=" + filterValue + "&SortColumn=" + SortColumn;
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }
  //string searchMember, string filterValue, int CurrentPage,  int pageSize
  GetPagining<T>(
    apiName: string,
    searchMember: string,
    filterValue: string,
    skip: number,
    pageSize: number,
    SortColumn: string = "",
    IsEqual: boolean = false
  ): Observable<T> {
    const url =
      this.apiBaseUrl +
      apiName +
      "/?searchMember=" +
      searchMember +
      "&filterValue=" +
      filterValue +
      "&skip=" +
      skip +
      "&pageSize=" +
      pageSize +
      "&SortColumn=" +
      SortColumn +
      "&IsEqual=" +
      IsEqual;
    return this.handleRequest(url, this.http.get<T>(url, this.authService.getRequestHeaders()));
  }
  GetFilterGrid<T>(apiName: string, filters: GridFilter[]): Observable<T> {
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.post<T>(url, JSON.stringify(filters), this.authService.getRequestHeaders()), filters);
  }
  searchToLookup(apiName: string, searchField: string, searchText: string): Observable<any> {
    const url = this.apiBaseUrl + apiName + "/GetLookup" + "/" + searchField + "/" + searchText;
    return this.handleRequest(url, this.http.get(url, this.authService.getRequestHeaders()));
  }

  saveReportFile(apiName: string, model: any): Observable<any> {
    const url = this.apiBaseUrl + apiName + "/SaveReportFile";
    return this.handleRequest(url, this.http.post(url, this.stringifyModel(model), this.authService.getRequestHeaders()), model);
  }

  upload(apiName: string, body: any): Observable<boolean> {
    let headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/octet-stream",
    });
    const url = this.apiBaseUrl + apiName;
    return this.handleRequest(url, this.http.post<boolean>(url, body), body);
  }

  getExcel<T>(apiName: string, params: any) {
    const headers = new HttpHeaders().set("Accept", "application/ms-excel");
    const url = this.apiBaseUrl + apiName;
    if (typeof params === "object") {
      return this.handleRequest(url, this.http.post<T>(url, params, { headers: headers, responseType: "blob" as "json", observe: "response" }));
    } else return this.handleRequest(url, this.http.get<T>(url, { headers: headers, responseType: "blob" as "json", observe: "response" }));
  }

  private handleRequest(apiName: string, observable: Observable<any>, model?: any): Observable<any> {
    let exist = this.isItOnTheList(model, apiName);
    if (exist == "exist") return this.requestQueueList[apiName].replySubject.asObservable();
    const subject = new ReplaySubject<any>(1);
    const queue: Queue = { replySubject: subject, model };
    if (exist === "existWithSameApiNameAndOtherModel") {
      const randomNumber = Math.floor(Math.random() * 123456789);
      apiName = apiName + randomNumber;
    }
    this.requestQueueList[apiName] = queue;
    return observable.pipe(
      tap((res) => this.handleSuccess(apiName, res)),
      catchError((err) => this.handleFailure(apiName, err)),
      finalize(() => this.deleteAndUnsubscribeQueueItem(apiName))
    );
  }

  private isItOnTheList(model: any, apiName: string): ApiStatusInQueueList {
    let exist: ApiStatusInQueueList = "notExist";
    if (model && !!this.requestQueueList[apiName]) {
      const stringifyModel = this.stringifyModel(model);
      if (this.requestQueueList[apiName].model === stringifyModel) exist = "exist";
      else exist = "existWithSameApiNameAndOtherModel";
    } else if (!!this.requestQueueList[apiName]) exist = "exist";
    return exist;
  }

  private handleSuccess(apiName: string, res: any): void {
    this.requestQueueList[apiName]?.replySubject.next(res);
    this.deleteAndUnsubscribeQueueItem(apiName);
  }

  private handleFailure(apiName: string, err: any): Observable<never> {
    this.requestQueueList[apiName]?.replySubject.error(err);
    this.deleteAndUnsubscribeQueueItem(apiName);
    return throwError(err);
  }

  private deleteAndUnsubscribeQueueItem(apiName: string): void {
    const queueItem = this.requestQueueList[apiName];
    if (queueItem) {
      queueItem.replySubject.unsubscribe();
      queueItem.model = null;
      queueItem.replySubject = null;
      delete this.requestQueueList[apiName];
    }
  }
}
